export enum PropertyInquirySource {
  ZILLOW = 'Zillow',
  MANUALLY_ADDED = 'Manually Added',
}
